import React from "react";
import { FiHome, FiMapPin, FiLayout } from "react-icons/fi";
import {
  getPropertyTypeIcon,
  parsePropertyInfoFromMessage,
} from "../../utils/analysisFormatter";

/**
 * Component hiển thị thông tin bất động sản (Structured Property Details)
 */
export const PropertyDetailsSection = ({ analysis }) => {
  const propertyInfo = parsePropertyInfoFromMessage(
    analysis.result?.chat_response?.user_message
  );

  // Nếu không có thông tin, không render
  if (Object.keys(propertyInfo).length === 0) {
    return null;
  }

  const propertyType = propertyInfo.type || "Bất động sản";
  const icon = getPropertyTypeIcon(propertyType);

  return (
    <section className="bg-white border border-gray-100 rounded-2xl p-4 sm:p-6 shadow-sm space-y-4">
      <div className="flex items-center gap-2">
        <h4 className="text-base font-semibold text-gray-900 flex items-center gap-2">
          <span className="text-lg">{icon}</span>
          Thông Tin Bất Động Sản
        </h4>
        <span className="text-sm font-medium text-white bg-blue-600 px-3 py-1 rounded-full">
          {propertyType}
        </span>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
        {/* Loại BĐS */}
        {propertyInfo.type && (
          <div className="bg-gradient-to-br from-blue-50 to-blue-100 border border-blue-200 rounded-lg p-3">
            <p className="text-xs uppercase text-blue-700 font-semibold mb-1">
              Loại BĐS
            </p>
            <p className="text-sm text-blue-900 font-medium">
              {propertyInfo.type}
            </p>
          </div>
        )}

        {/* Địa chỉ */}
        {propertyInfo.address && (
          <div className="bg-gradient-to-br from-green-50 to-green-100 border border-green-200 rounded-lg p-3">
            <p className="text-xs uppercase text-green-700 font-semibold mb-1 flex items-center gap-1">
              <FiMapPin size={14} />
              Địa Chỉ
            </p>
            <p className="text-sm text-green-900 font-medium break-words">
              {propertyInfo.address}
            </p>
          </div>
        )}

        {/* Dự án */}
        {propertyInfo.project && (
          <div className="bg-gradient-to-br from-purple-50 to-purple-100 border border-purple-200 rounded-lg p-3">
            <p className="text-xs uppercase text-purple-700 font-semibold mb-1">
              Dự Án
            </p>
            <p className="text-sm text-purple-900 font-medium">
              {propertyInfo.project}
            </p>
          </div>
        )}

        {/* Diện tích */}
        {propertyInfo.area && (
          <div className="bg-gradient-to-br from-orange-50 to-orange-100 border border-orange-200 rounded-lg p-3">
            <p className="text-xs uppercase text-orange-700 font-semibold mb-1 flex items-center gap-1">
              <FiLayout size={14} />
              Diện Tích
            </p>
            <p className="text-sm text-orange-900 font-medium">
              {propertyInfo.area}
            </p>
          </div>
        )}

        {/* Phòng ngủ */}
        {propertyInfo.bedrooms && (
          <div className="bg-gradient-to-br from-pink-50 to-pink-100 border border-pink-200 rounded-lg p-3">
            <p className="text-xs uppercase text-pink-700 font-semibold mb-1 flex items-center gap-1">
              <FiHome size={14} />
              Phòng Ngủ
            </p>
            <p className="text-sm text-pink-900 font-medium">
              {propertyInfo.bedrooms}
            </p>
          </div>
        )}

        {/* Phòng tắm */}
        {propertyInfo.bathrooms && (
          <div className="bg-gradient-to-br from-cyan-50 to-cyan-100 border border-cyan-200 rounded-lg p-3">
            <p className="text-xs uppercase text-cyan-700 font-semibold mb-1">
              Phòng Tắm
            </p>
            <p className="text-sm text-cyan-900 font-medium">
              {propertyInfo.bathrooms}
            </p>
          </div>
        )}

        {/* Tầng */}
        {propertyInfo.floor && (
          <div className="bg-gradient-to-br from-indigo-50 to-indigo-100 border border-indigo-200 rounded-lg p-3">
            <p className="text-xs uppercase text-indigo-700 font-semibold mb-1">
              Tầng
            </p>
            <p className="text-sm text-indigo-900 font-medium">
              {propertyInfo.floor}
            </p>
          </div>
        )}

        {/* Hướng */}
        {propertyInfo.direction && (
          <div className="bg-gradient-to-br from-teal-50 to-teal-100 border border-teal-200 rounded-lg p-3">
            <p className="text-xs uppercase text-teal-700 font-semibold mb-1">
              Hướng
            </p>
            <p className="text-sm text-teal-900 font-medium">
              {propertyInfo.direction}
            </p>
          </div>
        )}

        {/* Pháp lý */}
        {propertyInfo.legalStatus && (
          <div className="bg-gradient-to-br from-red-50 to-red-100 border border-red-200 rounded-lg p-3">
            <p className="text-xs uppercase text-red-700 font-semibold mb-1">
              Pháp Lý
            </p>
            <p className="text-sm text-red-900 font-medium">
              {propertyInfo.legalStatus}
            </p>
          </div>
        )}
      </div>
    </section>
  );
};

export default PropertyDetailsSection;
